<script setup>
defineOptions({ name: "HomePage" });
import { defineAsyncComponent } from "vue";
import Hero from "@/components/home/Hero.vue"; // acima do fold — carregado eagerly
import { useSeo } from "@/composables/useSeo";

// Componentes abaixo do fold — carregados de forma assíncrona para reduzir
// o bundle inicial e liberar a main thread mais cedo
const DashboardPreview = defineAsyncComponent(() => import("@/components/home/DashboardPreview.vue"));
const KPI = defineAsyncComponent(() => import("@/components/home/KPI.vue"));
const SolutionsSwitcher = defineAsyncComponent(() => import("@/components/home/SolutionsSwitcher.vue"));
const Features = defineAsyncComponent(() => import("@/components/home/Features.vue"));
const Clients = defineAsyncComponent(() => import("@/components/home/Clients.vue"));
const RecentPosts = defineAsyncComponent(() => import("@/components/home/RecentPosts.vue"));
const CTA = defineAsyncComponent(() => import("@/components/home/CTA.vue"));

useSeo({
  title: "Kali Sistemas - Soluções em Gestão Empresarial",
  description:
    "Sistemas inteligentes para gestão empresarial. Simplifique processos, aumente a produtividade e tome decisões mais assertivas com a Kali Sistemas.",
  image: "/dashboard.png",
});
</script>
<template>
  <Hero />
  <DashboardPreview />
  <KPI />
  <SolutionsSwitcher />
  <Features />
  <Clients />
  <RecentPosts />
  <CTA />
</template>
